import styled from 'styled-components'

export const LinkExternal = styled.a`
  color: #1d2943;
  font-family: 'Proxima Nova', sans-serif;
  font-size: 14px;
`
